import React from "react";
import { useTranslation } from "react-i18next";
import IndexSection from "components/indices/IndexSection";
const IndicesOverview = ({ indexDetails, indices, indexSetId = void 0 }) => {
  const { t } = useTranslation("indexsets");
  const indicesFilteredByTier = (indicesList, tier) => indicesList.filter((index) => index.tier === tier);
  const warmTierIndices = indicesFilteredByTier(indices, "WARM");
  const hotTierIndices = indicesFilteredByTier(indices, "HOT");
  const hotTierList = hotTierIndices.length > 0 ? hotTierIndices : indicesFilteredByTier(indices, void 0);
  const hotTierSubheading = t("overview.tiers.hot_description");
  const warmTierSubheading = t("overview.tiers.warm_description");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    IndexSection,
    {
      headline: t("overview.tiers.hot_title"),
      subheading: hotTierSubheading,
      indices: hotTierList,
      indexDetails,
      indexSetId
    }
  ), warmTierIndices.length > 0 && /* @__PURE__ */ React.createElement(
    IndexSection,
    {
      headline: t("overview.tiers.warm_title"),
      subheading: warmTierSubheading,
      indices: warmTierIndices,
      indexDetails,
      indexSetId
    }
  ));
};
export default IndicesOverview;
